import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';

import ProductLogo from '../../atoms/ProductLogo';
import SocialMediaIcons from '../../atoms/SocialMediaIcons';

import Styles from './styles';

const { productName } = Meteor.settings.public;

class Logout extends React.Component {
  componentDidMount() {
    const { setAfterLoginPath } = this.props;
    Meteor.logout(() => setAfterLoginPath(null));
  }

  render() {
    const { deployEnv } = this.props;
    return (
      <Styles.Logout>
        <ProductLogo deployEnv={deployEnv} />
        <h1>Stay safe out there.</h1>
        <p>{`Don\u0027t forget to like and follow ${productName} elsewhere on the web:`}</p>
        <SocialMediaIcons />
      </Styles.Logout>
    );
  }
}

Logout.propTypes = {
  deployEnv: PropTypes.string.isRequired,
  setAfterLoginPath: PropTypes.func.isRequired
};

export default Logout;
